module.exports = __webpack_public_path__ + "img/tb1.adca789b.svg";